// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"621":"423a17c6","743":"8412ba0f","917":"d11227e0"}[chunkId] + ".chunk.js";
};